module.exports = __webpack_public_path__ + "img/HSZHSY_IOS.7d98b5db.png";